module.exports = __webpack_public_path__ + "img/friends-logo1.c4040364.png";